/** @jsx jsx */

import { ComponentProps, PropsWithChildren } from 'react';

import { jsx, css } from '@emotion/core';

import ExtendedIcon from 'app/developer-v3/components/ExtendedIcon';

import Title from './Title';

const Styles = {
  root: css`
    flex: 1;
    margin-bottom: 20px;

    @media screen and (min-width: 900px) {
      margin-right: 10px;
      margin-bottom: 0px;
      width: 68%;
    }
  `,
};

type Props = PropsWithChildren<{
  icon: ComponentProps<typeof ExtendedIcon>['name'];
  title: string;
}>;

export default function Info({ children, icon, title }: Props) {
  return (
    <div css={Styles.root}>
      <Title icon={icon}>{title}</Title>
      {children}
    </div>
  );
}
